import { useEffect, useState } from 'react';

/**
 * The value, once it has stopped changing.
 *
 * The designer previews live, and the preview endpoint is the most expensive thing the API does
 * on request — it scores a room's whole season — so it is rate-limited per caller. Calling it per
 * keystroke would burn the allowance in seconds and put a queue of stale calculations between the
 * operator and the answer.
 *
 * Debouncing is only half of it: the caller should also key its cache on the definition, so
 * arriving back at a shape that has already been scored costs nothing at all.
 */
export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [settled, setSettled] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setSettled(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);

  return settled;
}
